<template>
  <div class="gf-field-compound">
    <FormSelect :options="pageTemplates" v-model="componentValue" :optional="true" />
  </div>
</template>

<script>
import { componentMixin } from '../Form/FormCommon'

export default {
  props: ["placeholder", "type", "item"],
  mixins: [componentMixin],
  watch: {
  },
  computed: {
    dataConfig() {
      return this.stores.auth.pageTemplates;
    },
    pageTemplates() {
      var result=[];
      for(var type in this.dataConfig || {}) {
        var typeData=this.dataConfig[type];
        result.push({
          text: typeData.title,
          value: type
        });
      }
      return result;
    },
  },
}
</script>
